/**
 * HUMM motion — IntersectionObserver one-shot scroll entrances for .humm-inview--io.
 *
 * Progressive enhancement only: content is fully visible (opacity: 1; transform: none)
 * before this script runs and if IO never fires.
 */
(() => {
  const IO_SELECTOR = '.humm-inview--io';
  const INVIEW_CLASS = 'is-humm-inview';
  const ENHANCED_CLASS = 'humm-motion-enhanced';

  if (typeof window.IntersectionObserver !== 'function') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  let observer = null;

  function ensureObserver() {
    if (observer) return observer;

    observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add(INVIEW_CLASS);
          observer.unobserve(entry.target);
        });
      },
      {
        root: null,
        rootMargin: '0px 0px -5% 0px',
        threshold: 0.12,
      }
    );

    return observer;
  }

  function bind(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const elements = scope.querySelectorAll(IO_SELECTOR);

    if (!elements.length) return false;

    document.documentElement.classList.add(ENHANCED_CLASS);

    const io = ensureObserver();

    elements.forEach((element) => {
      if (element.classList.contains(INVIEW_CLASS)) return;
      io.observe(element);
    });

    return true;
  }

  function init() {
    bind(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    if (!event.target) return;
    bind(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const section = event.target?.closest?.('[id^="shopify-section"]');
    bind(section || document);
  });
})();
